"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRootSpectrumPreference = void 0;
var _react = require("react");
var _cdsUtils = require("@cbhq/cds-utils");
var _context = require("./context");
const useRootSpectrumPreference = () => {
  const context = (0, _react.useContext)(_context.RootSpectrumPreferenceContext);
  if (!(0, _cdsUtils.isProduction)() && !context) {
    // eslint-disable-next-line no-console
    console.error('Cannot use `useRootSpectrumPreference` outside of RootSpectrumPreferenceProvider');
  }
  return context !== null && context !== void 0 ? context : 'system';
};
exports.useRootSpectrumPreference = useRootSpectrumPreference;